import React from 'react';
import { Image, ImageBackground, StyleSheet, Text, View } from 'react-native';

import { BGCollectBtnWrapper, BGTimerWrapper } from '../../../../assets';
import Centered from '../../../../shared/Centered';
import { inset } from '../../../../utils/helpers/css';
import { bonusGamesModalStyles } from './styles';

export interface IPlatformUIProps {
	isSmall: boolean;
	containerScale: number;
	/** Optional; used on native for smallContainerStyle when provided */
	width?: number;
	isDesktop?: boolean;
	isWeb: boolean;
}

export function getPlatformUI({
	isSmall,
	containerScale,
	width,
	isDesktop,
	isWeb,
}: IPlatformUIProps) {
	const MODAL_HORIZONTAL_OVERHEAD = 46;
	const smallContainerStyle = isDesktop
		? { width: 390 }
		: {
				width:
					width !== undefined
						? Math.max(200, width - 16 - MODAL_HORIZONTAL_OVERHEAD)
						: ('88%' as const),
			};
	const contentWrapperStyles = isSmall
		? { paddingHorizontal: 0, width: '100%' as const }
		: undefined;

	return {
		modalProps: isWeb
			? {
					closeButtonSize: 'big' as const,
					closeButtonStyles: {
						...bonusGamesModalStyles.buttons,
						top: -23,
						right: isSmall ? -2 : 20,
						transform: [{ scale: isSmall ? 1.4 : 1 }],
					},
					containerStyles: {
						maxWidth: undefined,
						marginTop: isSmall ? 30 : 60,
						transform: [{ scale: isSmall ? 1 : containerScale }],
					},
					contentWrapperStyles,
				}
			: {
					closeButtonSize: 'big' as const,
					closeButtonStyles: {
						...bonusGamesModalStyles.buttons,
						top: -23,
						right: isSmall ? -2 : 20,
						transform: [{ scale: isSmall ? 1.4 : 1 }],
					},
					containerStyles: {
						maxWidth: isSmall && width !== undefined ? width - 16 : undefined,
						marginTop: isSmall ? 30 : 60,
						transform: [{ scale: isSmall ? 1 : containerScale }],
					},
					contentWrapperStyles,
				},

		smallContainerStyle,

		renderSmallTimer: ({ timeText }: { timeText: string }) =>
			isWeb ? (
				<ImageBackground
					source={BGCollectBtnWrapper}
					style={[platformStyles.webTimerBg, isSmall ? { marginLeft: 8 } : null]}
				>
					<View style={platformStyles.webTimerInner}>
						<View style={platformStyles.webTimerBox}>
							<Image source={BGTimerWrapper} style={platformStyles.webTimerImg} />
							<Centered style={{ ...inset(0), position: 'absolute', top: 10 }}>
								<Text style={platformStyles.webTimerText} numberOfLines={1} ellipsizeMode='tail'>
									{timeText}
								</Text>
							</Centered>
						</View>
					</View>
				</ImageBackground>
			) : (
				<View style={platformStyles.nativeTimerHost}>
					<View
						style={[
							platformStyles.nativeTimerShell,
							{
								width: width !== undefined ? width * 0.28 : 200,
								marginLeft: isSmall ? 8 : 0,
							},
						]}
					>
						<View style={[platformStyles.nativeTimerRow, { marginTop: isSmall ? 2 : 20 }]}>
							<ImageBackground
								source={BGTimerWrapper}
								style={[
									platformStyles.nativeTimerImgBg,
									{
										width: width !== undefined ? width * 0.22 : 200,
									},
								]}
							>
								<Centered style={{ ...inset(0), position: 'absolute' }}>
									<Text
										style={platformStyles.nativeTimerText}
										numberOfLines={1}
										ellipsizeMode='tail'
									>
										{timeText}
									</Text>
								</Centered>
							</ImageBackground>
						</View>
					</View>
				</View>
			),
	};
}

const platformStyles = StyleSheet.create({
	webTimerBg: {
		width: 100,
		position: 'relative',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 6,
	},
	webTimerInner: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	webTimerBox: {
		width: 125,
		height: 30,
		position: 'relative',
		paddingRight: 2,
		marginTop: 4,
	},
	webTimerImg: {
		width: 120,
		height: 40,
	},
	webTimerText: {
		color: 'white',
		fontWeight: '900',
		fontSize: 13,
		width: 120,
		height: 20,
		textAlign: 'center',
	},
	nativeTimerBg: {
		height: 30,
		position: 'relative',
		alignSelf: 'flex-start',
	},
	nativeTimerShell: {
		height: 30,
		position: 'relative',
		alignSelf: 'flex-start',
	},
	nativeTimerHost: {
		width: '100%',
		alignItems: 'flex-start',
	},
	nativeTimerRow: {
		width: '100%',
		height: 20,
		position: 'relative',
		paddingRight: 2,
		marginBottom: 2,
		justifyContent: 'center',
		alignItems: 'center',
	},
	nativeTimerImgBg: {
		height: 40,
	},
	nativeTimerText: {
		color: 'white',
		fontWeight: '900',
		fontSize: 14,
		width: 120,
		textAlign: 'center',
	},
});
